module.exports = __webpack_public_path__ + "assets/img/empty-pic.053edcc7.png";